import React from 'react';
import TypoBlock from './TypoBlock';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import GestureIcon from '@mui/icons-material/Gesture';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
// import BallotIcon from '@mui/icons-material/Ballot';
import BlurOnIcon from '@mui/icons-material/BlurOn';
// import BorderColorIcon from '@mui/icons-material/BorderColor';
// import CategoryIcon from '@mui/icons-material/Category';
// import ClassIcon from '@mui/icons-material/Class';
// import DashboardIcon from '@mui/icons-material/Dashboard';
import EditIcon from '@mui/icons-material/Edit';
// import ErrorIcon from '@mui/icons-material/Error';
// import ExtensionIcon from '@mui/icons-material/Extension';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
// import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import WhatshotIcon from '@mui/icons-material/Whatshot';
import HelpIcon from '@mui/icons-material/Help';
import HdrOffIcon from '@mui/icons-material/HdrOff';




export default function QuandConsulter() {
  return (
    <TypoBlock id='Consulter'>
      <Typography variant="h1">
        Quand Consulter?
      </Typography>
      <Grid
        container 
        direction="row"
        // justify="center"
        alignItems="stretch"
        spacing={2}
        sx={{
          marginTop: 1,
          marginBottom: 3,
        }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <FingerprintIcon sx={{ mr: 1 }}/>
            Manque de soin
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <HourglassEmptyIcon sx={{ mr: 1 }}/>
            Lenteur
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <HelpIcon sx={{ mr: 1 }}/>
            Difficultés d'apprentissage
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <FlashOnIcon sx={{ mr: 1 }}/>
            Douleurs
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <NewReleasesIcon sx={{ mr: 1 }}/>
            Refus d'écrire
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <VisibilityOffIcon sx={{ mr: 1 }}/>
            Illisibilité
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <GestureIcon sx={{ mr: 1 }}/>
            Manque de fluidité
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <FitnessCenterIcon sx={{ mr: 1 }}/>
            Manque d'endurance
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <BlurOnIcon sx={{ mr: 1 }}/>
            Mauvaise présentation<br/>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <AirlineSeatReclineNormalIcon sx={{ mr: 1 }}/>
            Posture inadaptée
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <EditIcon sx={{ mr: 1 }}/>
            Préhension difficile
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1">
            <HdrOffIcon sx={{ mr: 1 }}/>
            Oubli de lettres
          </Typography>
        </Grid>
      </Grid>
      <Typography variant="body1">   
        Ces signes sont autant d'indicateurs d'un trouble de l'écriture, pour lequel il existe une prise en charge.
      </Typography>
    </TypoBlock>
  );
}